module.exports = __webpack_public_path__ + "img/fa5b15a.png";